import React from 'react';
import ComponentRegistry from "../../Common/ComponentRegistry";

export default class LocalStorageWidget extends React.Component {
    constructor(props) {
        super(props);

        this.store = ComponentRegistry.getStore(this.props.store);

        this.store.listen(value => localStorage.setItem(this.props.name, JSON.stringify(value)));
    }

    componentDidMount() {
        let value = localStorage.getItem(this.props.name);
        if (value !== null) {
            this.store.load(JSON.parse(value));
        }
    }

    render() {
        return null;
    }
}



// WEBPACK FOOTER //
// ./src-js/Fratello/Common/Widgets/LocalStorageWidget.jsx